import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Disc3, Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user && user.role === "admin") navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Connexion impossible");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink px-4 grain">
      <div className="w-full max-w-md relative z-10">
        <div className="text-center mb-8">
          <Disc3 className="w-12 h-12 text-mustard mx-auto spin-vinyl" />
          <h1 className="font-display font-black text-2xl mt-4">AJDR<span className="text-mustard">.</span> Admin</h1>
          <p className="text-cream/50 text-sm mt-1 font-mono2">Espace de gestion</p>
        </div>

        <form onSubmit={submit} data-testid="admin-login-form" className="glass rounded-3xl p-8 space-y-4">
          <label className="block">
            <span className="text-xs text-cream/50">Email</span>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="admin-input mt-1 w-full rounded-lg border border-white/10 px-4 py-3 focus:border-mustard focus:outline-none" />
          </label>
          <label className="block">
            <span className="text-xs text-cream/50">Mot de passe</span>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="admin-input mt-1 w-full rounded-lg border border-white/10 px-4 py-3 focus:border-mustard focus:outline-none" />
          </label>
          <button data-testid="login-submit" type="submit" disabled={loading}
            className="btn-mustard rounded-full w-full py-3 inline-flex items-center justify-center gap-2 disabled:opacity-60">
            <Lock className="w-4 h-4" /> {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>

        <button onClick={() => navigate("/")} className="mt-6 mx-auto block text-sm text-cream/50 hover:text-mustard transition">← Retour au site</button>
      </div>
    </div>
  );
}
